import { action, makeObservable, observable } from "mobx";

class PromoStore {

  promoModalIsOpen = false;
  promoButtonIsVisible = false;

  constructor() {
    makeObservable(this, {
      promoModalIsOpen: observable,
      promoButtonIsVisible: observable,
      setPromoModalIsOpen: action.bound,
      setPromoButtonIsVisible: action.bound,
    })
  }

  setPromoModalIsOpen = (promoModalIsOpen: boolean) => {
    this.promoModalIsOpen = promoModalIsOpen;
  }

  setPromoButtonIsVisible = (promoButtonIsVisible: boolean) => {
    this.promoButtonIsVisible = promoButtonIsVisible;
  }

}

export const promoStore = new PromoStore();